import { Component, OnInit } from "@angular/core";
import { Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { Department } from "src/app/models/Department";
import { Tool } from "src/app/models/Tool";
import { ToolUpdate } from "src/app/models/ToolUpdate";
import { ModalComponent, ModalService } from "src/app/services/modal.service";
import { ToolService } from "src/app/services/tool.service";

import { CompanyService } from "./../../services/company.service";

@Component({
  selector: "department-modal",
  templateUrl: "./department-modal.component.html",
  styleUrls: ["./department-modal.component.scss"],
  standalone: false,
})
export class DepartmentModalComponent
  implements OnInit, ModalComponent<DepartmentModalComponent, Tool>
{
  faSpinner = faSpinner;
  isLoading: boolean;
  departments: Department[];
  constructor(
    private companyService: CompanyService,
    private toolService: ToolService,
    public modalService: ModalService,
    @Inject(MAT_DIALOG_DATA) public data: Tool,
    public dialogRef: MatDialogRef<DepartmentModalComponent, void>,
  ) {}

  ngOnInit() {
    this.getDepartments();
  }

  getDepartments() {
    this.companyService.getDepartments(this.data.companyId).subscribe((response) => {
      if (!response) return;

      this.departments = response;
    });
  }

  updateDepartment(departmentName: string) {
    this.isLoading = true;
    this.toolService
      .updateDepartment(this.data.companyId, this.data.serialNumber, {
        ...new ToolUpdate(),
        department: departmentName,
      })
      .subscribe(
        () => {
          this.isLoading = false;

          this.data.department = departmentName;

          this.modalService.close();
        },
        () => (this.isLoading = false),
      );
  }
}
